import initialState from 'redux/initialState';
import types from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

import { Communication } from 'types';

type CommunicationAction = {
  type: string;
  communications?: Communication[];
  communication?: Communication;
  communicationId?: string;
};

const resetStateSociety = () => initialState.communications;

const getCommunications = (action: CommunicationAction) =>
  action.communications;

const createCommunication = (
  communications: Communication[],
  action: CommunicationAction
) => [action.communication, ...communications];

const updateCommunication = (
  communications: Communication[],
  action: CommunicationAction
) =>
  communications?.map((communication: Communication) =>
    communication._id === action?.communication?._id
      ? action.communication
      : communication
  );

const deleteCommunication = (
  communications: Communication[],
  action: CommunicationAction
) =>
  communications?.filter(
    (communication: Communication) =>
      communication._id !== action.communicationId
  );

export default function reducer(
  communications = initialState.communications,
  action: CommunicationAction
) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case types.GET_COMMUNICATIONS:
      return getCommunications(action);

    case types.CREATE_COMMUNICATION:
      return createCommunication(communications, action);

    case types.UPDATE_COMMUNICATION:
      return updateCommunication(communications, action);

    case types.DELETE_COMMUNICATION:
      return deleteCommunication(communications, action);

    default:
      return communications;
  }
}
